/**
 *
 * NOTICE OF LICENSE
 *
 * This source file is released under commercial license by Lamia Oy.
 *
 * @copyright Copyright (c) 2017 Lamia Oy (https://lamia.fi)
 *
 */

import Vue from 'vue';
import breakpoints from '@lamiaoy/breakpoints';

export default function() {
    Vue.prototype.$breakpoints = breakpoints;
}
